import StatementIcon from '@material-ui/icons/Assessment';
import StatementList from './StatementList';

export default {
    list: StatementList,
    icon: StatementIcon,
};
